var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import Flex from "@irati/ui/src/Flex";
import Icon from "@irati/ui/src/Icon";
import { greys } from "@irati/ui/src/global/colors";
import { Label2 } from "@irati/ui/src/Labels";
import { onePxElevation } from "@irati/ui/src/global/elevation";
var StyledFlex = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: 4px;\n  color: ", ";\n  ", "\n"], ["\n  background-color: ", ";\n  border-radius: 4px;\n  color: ", ";\n  ", "\n"])), greys.white, greys.mediumDark, onePxElevation);
var OnlinePin = styled(Icon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  stroke: ", ";\n  fill: none;\n  margin-right: 5px;\n"], ["\n  stroke: ", ";\n  fill: none;\n  margin-right: 5px;\n"])), greys.black);
var PerksGoOnlinePill = /** @class */ (function (_super) {
    __extends(PerksGoOnlinePill, _super);
    function PerksGoOnlinePill() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PerksGoOnlinePill.prototype.render = function () {
        var text = this.props.text;
        return (React.createElement(StyledFlex, { alignItems: "center", padding: "5px 8px" },
            React.createElement(OnlinePin, { size: 12, icon: "online" }),
            React.createElement(Label2, null, text)));
    };
    return PerksGoOnlinePill;
}(PureComponent));
export default PerksGoOnlinePill;
var templateObject_1, templateObject_2;
